import { observable } from 'mobx';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { ITextBlockResponse } from '~/types/server.types';

export class CXTextBlock extends CXBaseBlock {
    type: 'text_block';
    @observable content: string;

    constructor(
        block: ITextBlockResponse,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevision, rootStore);
        this.type = block.type;
    }
}
